import { strategies } from "./strategies";
export const defaultRankingWeights = {
    profitFactor: 0.18,
    expectancy: 0.18,
    maxDrawdown: 0.16,
    recentPerformance: 0.16,
    outOfSample: 0.22,
    trades: 0.1,
    stability: 0
};
export function scoreBacktest(metrics, weights = defaultRankingWeights) {
    const drawdownScore = Math.max(0, 1 - metrics.maxDrawdown / 8);
    const tradeScore = Math.min(1, metrics.trades / 30);
    const score = normalize(metrics.profitFactor, 0, 3) * weights.profitFactor +
        normalize(metrics.expectancy, -0.4, 0.8) * weights.expectancy +
        drawdownScore * weights.maxDrawdown +
        normalize(metrics.recentPerformance, -0.5, 0.8) * weights.recentPerformance +
        normalize(metrics.outOfSampleExpectancy, -0.4, 0.8) * weights.outOfSample +
        tradeScore * weights.trades +
        metrics.stabilityScore * weights.stability;
    const warningsPenalty = (metrics.tooFewTradesWarning ? 0.12 : 0) + (metrics.overfitWarning ? 0.18 : 0);
    return Math.max(0, Math.round((score - warningsPenalty) * 100));
}
export function rankStrategies(symbol, metrics, previous = []) {
    return metrics
        .map((metric) => {
        const strategy = strategies.find((item) => item.id === metric.strategyId);
        const old = previous.find((item) => item.strategyId === metric.strategyId);
        return {
            symbol,
            strategyId: metric.strategyId,
            strategyName: strategy?.name ?? metric.strategyId,
            rank: 0,
            score: scoreBacktest(metric),
            previousRank: old?.rank,
            reason: rankingReason(metric),
            changedAt: new Date().toISOString()
        };
    })
        .sort((a, b) => b.score - a.score)
        .map((item, index) => ({ ...item, rank: index + 1 }));
}
function rankingReason(metric) {
    const parts = [
        `PF ${metric.profitFactor.toFixed(2)}`,
        `expectancy ${metric.expectancy.toFixed(2)}R`,
        `OOS ${metric.outOfSampleExpectancy.toFixed(2)}R`,
        `DD ${metric.maxDrawdown.toFixed(2)}R`
    ];
    if (metric.tooFewTradesWarning)
        parts.push("low sample warning");
    if (metric.overfitWarning)
        parts.push("overfit warning");
    return parts.join("; ");
}
function normalize(value, min, max) {
    return Math.max(0, Math.min(1, (value - min) / (max - min)));
}
